import { Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { IOrganisation } from '@portal/entity-services/interfaces/src';
import { TemplateParameters } from '@portal/entity-services/interfaces/src/lib/organisations/interfaces/reseller.interface';
import { FormBase } from '@portal/shared/ui/form/src';
import { DetailResellerForm } from '../../../interfaces/detail-reseller-form.interface';
import { FormSharedService } from '../../form/form-shared.service';

@UntilDestroy()
@Component({
    selector: 'portal-detail-reseller-form',
    templateUrl: 'detail-reseller-form.component.html',
    standalone: false
})
export class DetailResellerFormComponent
  extends FormBase<DetailResellerForm>
  implements OnInit, OnChanges
{
  @Input() entityUid: string;
  @Input() disabled: boolean;
  @Input() organisation: IOrganisation;
  @Input() templateParameters: TemplateParameters;

  constructor(
    protected elementRef: ElementRef,
    private fb: UntypedFormBuilder,
    private formSharedService: FormSharedService,
  ) {
    super(fb.group({}), elementRef);
    this.setFormGroup(this.createResellerForm());
  }

  ngOnInit(): void {
    this.templateParametersForm.patchValue({
      ...this.templateParametersForm.value,
      ...this.templateParameters,
    });

    /***
     * getting White Label editor form
     * which was opened with routing
     */
    this.formSharedService.whiteLabelPreviewFormValues$
      .pipe(untilDestroyed(this))
      .subscribe((templateParameters: TemplateParameters) => {
        if (templateParameters) {
          this.templateParametersForm.patchValue({
            ...this.templateParametersForm.value,
            ...templateParameters,
          });
        }
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);

    if (changes.organisation && this.organisation) {
      this.updateOrganisationFields(this.organisation);
    }
  }

  private createResellerForm(): UntypedFormGroup {
    return this.fb.group({
      organisation: this.createOrganisationForm(),
      templateParameters: this.createTemplateForm(),
    });
  }

  private createTemplateForm(): UntypedFormGroup {
    return this.fb.group({
      logo: [[]],
      favicon: [[]],
      pageStyle: this.fb.group({
        font: this.fb.array([this.fb.control('')]),
        navBar: this.fb.group({
          navbarBackgroundColor: [''],
          navbarItemColor: [''],
        }),
        brand: this.fb.group({
          brandBackground: [''],
          brandText: [''],
          brandOutlinedText: [''],
        }),
        dangerButton: this.fb.group({
          dangerButtonBackgroundColor: [''],
        }),
      }),
    });
  }

  private createOrganisationForm(): UntypedFormGroup {
    return this.fb.group({
      loginDomainName: [''],
      domainName: [''],
      emailDomainName: [''],
    });
  }

  private updateOrganisationFields(organisation: IOrganisation): void {
    this.organisationForm?.patchValue(organisation);
  }

  get templateParametersForm(): UntypedFormGroup {
    return this.form.get('templateParameters') as UntypedFormGroup;
  }

  get organisationForm(): UntypedFormGroup {
    return this.form.get('organisation') as UntypedFormGroup;
  }

  get domainNameControl(): UntypedFormControl {
    return this.organisationForm?.get('domainName') as UntypedFormControl;
  }

  get emailDomainNameControl(): UntypedFormControl {
    return this.organisationForm?.get('emailDomainName') as UntypedFormControl;
  }
}
